import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

import useLayersToolbarStyles from '../../styles';
import { GroupProps } from './types';

const Group: React.FunctionComponent<GroupProps> = ({
  id,
  name,
  title,
  expanded,
  onToggle,
  titleAddons,
  children,
}) => {
  const classes = useLayersToolbarStyles();
  const renderGroup = () => {
    return (
      <Accordion id={id} className={classes.accordion} expanded={expanded}>
        <AccordionSummary
          classes={{
            content: classes.accordionTitleContent,
            root: classes.accordionTitleRoot,
          }}
          id={`${id}-title`}
        >
          <Typography
            variant='h6'
            style={{ lineHeight: `25px`, height: 25, width: titleAddons ? '80%' : '90%' }}
            onClick={() => onToggle(name)}
          >
            <strong>{title}</strong>
          </Typography>

          {titleAddons && <div className={classes.titleAddonsWrapper}>{titleAddons}</div>}

          <ExpandMore
            onClick={() => onToggle(name)}
            className={clsx(classes.arrow, {
              [classes.arrowExpanded]: expanded,
              [classes.autoLeftMargin]: !titleAddons,
            })}
          />
        </AccordionSummary>
        <AccordionDetails id={`${id}-children`}>{children}</AccordionDetails>
      </Accordion>
    );
  };

  return renderGroup();
};

export default Group;
